import axios from "axios";

const keylessAxios = axios.create({
  baseURL: process.env.REACT_APP_WEB_API_URL,
});

const keylessIdHeaders = (token) => ({
  headers: {
    "x-keyless-id": token, 
    "Accept-Language": JSON.parse(localStorage.getItem('language'))?.lang || 'pt'
  },
});

export async function getKeylessSession(token) {
  return (await keylessAxios.get("/keyless", keylessIdHeaders(token))).data;
}

export async function validateKeylessLocation(token, location) {
  return (
    await keylessAxios.post(
      "/keyless/validate-location",
      location,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function sendKeylessPin(token) {
  return (
    await keylessAxios.post("/keyless/pin", undefined, keylessIdHeaders(token))
  ).data;
}

export async function validateKeylessPin(token, pin) {
  return (
    await keylessAxios.post(
      "/keyless/pin-validate",
      { pin },
      keylessIdHeaders(token)
    )
  ).data;
}

export async function validateKeylessRA(token) {
  return (
    await keylessAxios.post(
      "/keyless/validate-rental-agreement",
      undefined,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function keylessSignRA(token, signature) {
  return (
    await keylessAxios.post(
      "/keyless/sign-rental-agreement",
      { signature },
      keylessIdHeaders(token)
    )
  ).data;
}

export async function getKeylessSessionRAReview(token) {
  return (
    await keylessAxios.get("/keyless/rental-agreement", keylessIdHeaders(token))
  ).data;
}

export async function validateKeylessVehicleQRCode(token, qrCode) {
  return (
    await keylessAxios.post(
      "/keyless/validate-vehicle",
      { qrCode },
      keylessIdHeaders(token)
    )
  ).data;
}

export async function keylessOpenDoors(token) {
  return (
    await keylessAxios.post(
      "/keyless/open-doors",
      undefined,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function finishKeylessSession(token) {
  return (
    await keylessAxios.post(
      "/keyless/finish",
      undefined,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function createSelfCheckoutUrl(token) {
  return (
    await keylessAxios.post(
      "/keyless/self-checkout",
      undefined,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function confirmSelfCheckoutUrl(token) {
  return (
    await keylessAxios.post(
      "/keyless/confirm-self-checkout",
      undefined,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function proceedNextSetp(token) {
  return (
    await keylessAxios.post(
      "/keyless/next-step",
      undefined,
      keylessIdHeaders(token)
    )
  ).data;
}

export async function getConventionDetails(token) {
  return (
    await keylessAxios.get(
      "/convention?token=" + token,
    )
  ).data;
}

export async function conventionOpenDoors(token) {
  return (
    await keylessAxios.post(
      "/convention/open-doors?token=" + token,
    )
  ).data;
}
